import styled from "styled-components";

const IconWrapper = styled.div`
    position: relative;
`;

export default IconWrapper;